import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

export const TestDefinitionsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListTestDefinitions}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action={rbacActions.CreateTestDefinition}>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetTestDefinition}>
                        <EditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
